// extracted by mini-css-extract-plugin
export default {"equal":"oCESV+XqhdPtpbhvhSOYOQ=="};